//import data from '../db/data.json';

export async function Calculate(formData){

    let montoGanadoTotal = 0;
    let montoGanado = 0;
    //let TNA = formData.tna;
    let TNA = formData.selectBanco;
    let TEM = (TNA/100)/365;
    let parteone = (1+(TEM*formData.numberCantDias));
    let partetwo = (365/formData.numberCantDias);

    let TEA =((Math.pow(parteone, partetwo)-1)*100);

    montoGanado = formData.numberMontoInvertir * ((TNA/100) * formData.numberCantDias / 365)
    montoGanadoTotal = parseInt(formData.numberMontoInvertir) + montoGanado

    const result = {"montoGanadoTotal": numberFormat(montoGanadoTotal),"montoInvertido" : numberFormat(formData.numberMontoInvertir), "montoGanado": numberFormat(montoGanado), "TNA": TNA, "TEA": numberFormat(TEA), "banco": "ejemplo"}

    return result

  }
  
function numberFormat(number){
  const numberWithDot = number.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2})
  
  return numberWithDot
}

export default Calculate;